import { defineComponent as n } from "vue";
const o = n({
  name: "CsLoadingSpinner"
});
export {
  o as default
};
